import { useGetTransitControlListQuery } from '../services';
import { TransitControlFilter } from '../models';

interface UseTransitControlListProps {
  filters: TransitControlFilter;
  page: number;
  pageSize: number;
}

const hasRequiredFilters = (filters: TransitControlFilter): boolean =>
  Boolean(
    filters.originStatusId &&
      filters.destinationStatusId &&
      filters.dateFrom &&
      filters.dateTo
  );

const useTransitControlList = ({ filters, page, pageSize }: UseTransitControlListProps) => {
  const shouldFetch = hasRequiredFilters(filters);

  const {
    data: transitControlData,
    isLoading: isTransitControlLoading,
    isFetching: isTransitControlFetching,
    error: transitControlError,
  } = useGetTransitControlListQuery(
    { paginated: { page, pageSize }, filters },
    { skip: !shouldFetch, refetchOnMountOrArgChange: true }
  );

  return {
    items: transitControlData?.items || [],
    totalItems: transitControlData?.count || 0,
    totalPages: transitControlData?.count ? Math.ceil(transitControlData.count / pageSize) : 0,
    isTransitControlLoading: shouldFetch && isTransitControlLoading,
    isTransitControlFetching: shouldFetch && isTransitControlFetching,
    transitControlError,
    hasRequiredFilters: shouldFetch,
  };
};

export default useTransitControlList;
